import axios from '@/libs/api.request'
import config from '@/config'

const workFlowBaseUrl = config.baseWorkflowUrl + '/api/v1/'

export const CodeReleaseFlowEnclosureBaseUrl = workFlowBaseUrl + 'data/test_report_enclosure/'
export const CodeReleaseFlowUploadEnclosureUrl = workFlowBaseUrl + 'code_release_flow/upload_enclosure/'

export const getCodeReleaseFlow = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_flow/',
    params: params,
    traditional: true,
    method: 'get'
  })
}

export const createCodeReleaseFlow = (data) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_flow/',
    data: data,
    method: 'post'
  })
}

export const detailCodeReleaseFlow = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_flow/' + id + '/',
    method: 'get'
  })
}

export const deleteCodeReleaseFlow = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_flow/' + id + '/',
    method: 'delete'
  })
}

export const submitCodeReleaseFlowTestReport = (id, content) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_flow/' + id + '/submit_test_report/',
    data: { content: content },
    method: 'put'
  })
}

export const applyCodeReleaseFlowBuildProduct = (id, data) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_flow/' + id + '/apply_build_product/',
    data: data,
    method: 'post'
  })
}

export const applyCodeReleaseFlowBuildProductConfirm = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_flow/' + id + '/apply_build_product_confirm/',
    method: 'post'
  })
}

export const applyCodeReleaseFlowRollback = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_flow/' + id + '/rollback_product/',
    method: 'post'
  })
}

export const refuseCodeReleaseFlowBuildTask = (id, content) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_flow/' + id + '/refuse/',
    data: { content: content },
    method: 'post'
  })
}

export const updateModuleCodeReleaseFlow = (id, data) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_flow/' + id + '/update_module/',
    data: data,
    method: 'put'
  })
}

export const getCodeReleaseFlowBuildTasks = (jobFlowId) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_build_task/',
    params: { job_flow: jobFlowId },
    method: 'get'
  })
}

export const updateCodeReleaseFlowBuildTasks = (id, data) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_build_task/' + id + '/',
    data: data,
    method: 'put'
  })
}

export const buildCodeReleaseFlowBuildTasks = (id, jobName, parameter) => {
  let data = {
    job_name: jobName
  }
  if (parameter) {
    data.parameter = parameter
  }
  return axios.request({
    url: workFlowBaseUrl + 'code_release_build_task/' + id + '/build/',
    data: data,
    method: 'post'
  })
}

export const rollbackCodeReleaseFlowBuildTasks = (id, jobName, parameter) => {
  let data = {
    job_name: jobName
  }
  if (parameter) {
    data.parameter = parameter
  }
  return axios.request({
    url: workFlowBaseUrl + 'code_release_build_task/' + id + '/rollback/',
    data: data,
    method: 'post'
  })
}

export const cancelBuildCodeReleaseFlowBuildTasks = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_build_task/' + id + '/cancel_build/',
    method: 'post'
  })
}

export const cancelQueueCodeReleaseFlowBuildTasks = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_build_task/' + id + '/cancel_queue/',
    method: 'post'
  })
}

export const updateCodeReleaseFlowBuildTaskBuildNumber = (id, number) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_build_task/' + id + '/update_number/',
    data: { number: number },
    method: 'post'
  })
}

export const editCodeAddressApi = (data) => {
  return axios.request({
    url: workFlowBaseUrl + 'edit_doc_code_address/',
    data: data,
    method: 'post'
  })
}

export const updateCodeReleaseFlowStatus = (id, data) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_flow/' + id + '/update_status/',
    data: data,
    method: 'put'
  })
}

export const appointApi = (id, data) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_flow/' + id + '/appoint/',
    data: data,
    method: 'put'
  })
}

export const verifyOkApi = (id, data) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_flow/' + id + '/verify/',
    data: data,
    method: 'put'
  })
}

export const notifyOkApi = (id, data) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_flow/' + id + '/notify/',
    data: data,
    method: 'put'
  })
}

export const GetALLEmails = () => {
  return axios.request({
    url: workFlowBaseUrl + 'email_all_list/',
    method: 'get'
  })
}

export const getTenantReleaseSteps = (data) => {
  return axios.request({
    url: workFlowBaseUrl + 'get_tenant_release_steps/',
    data: data,
    method: 'post'
  })
}

// 按项目统计每月发布数（可自定义时间节点）
export const getCodeReleaseProjectMon = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_project_mon/',
    params: params,
    method: 'get'
  })
}

// 按项目发布次数 Top10
export const getCodeReleaseProjectTop = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_project_top/',
    params: params,
    method: 'get'
  })
}

// 按发布状态统计各状态（已发布、待审批等）下拉切换不同项目
export const getCodeReleaseStatus = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'code_release_status/',
    params: params,
    method: 'get'
  })
}

// 自定义导出代码发布
export const GetCodeReleaseExport = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'export_code_release/',
    params: params,
    method: 'get'
  })
}
